import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-driver-fullscreen',
  templateUrl: './driver-fullscreen.component.html',
  styleUrls: ['./driver-fullscreen.component.scss']
})
export class DriverFullscreenComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
